<template>
  <div class="td-login">
    <el-row>
      <div class="td-form-item">
        <el-col :span="24">
          <el-input
            placeholder="请输入手机号"
            v-model="params.Mobile"
            style="width: 100%"
            prefix-icon="icon font_family icon-td-phone"
          ></el-input>
        </el-col>
      </div>
      <div class="td-form-item">
        <el-col :span="24">
          <el-input
            type="password"
            placeholder="请输入密码"
            v-model="params.Password"
            style="width: 100%"
            prefix-icon="icon font_family icon-td-mima"
          ></el-input>
        </el-col>
      </div>
      <div class="td-form-item">
        <el-col :span="17">
          <el-input
            placeholder="请输入验证码"
            v-model="params.ValidateCode"
            style="width: 100%"
            prefix-icon="icon font_family icon-td-youxiang"
          ></el-input>
        </el-col>
        <el-col :span="7">
          <img
            width="100%"
            height="40"
            v-bind:src="ImgByteArray"
            @click="loadValidateCode()"
          />
        </el-col>
      </div>
      <div class="td-form-item td-form-doctor-label">
        <el-col :span="12">
          <router-link to="/tdRegistered">新用户注册</router-link>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <router-link to="/tdForget">忘记密码?</router-link>
        </el-col>
      </div>
      <div class="td-form-item">
        <el-col :span="24" style="text-align: center">
          <el-button
            type="primary"
            class="td-btn-doctor-primary"
            style="width: 80%"
            round
            @click="btnSubmit()"
            >登录</el-button
          >
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import AuthService from "../_services/auth.service";
import UserService from "../_services/user.service";
import DoctorService from "../_services/doctor.service";
import HospitalService from "../_services/hospital.service";
import wxService from "../_services/wx.service";
export default {
  name: "TianDingLoginComponent",
  data() {
    return {
      params: {
        Mobile: "",
        Password: "",
        ValidateCode: "",
        OpenID: "",
        Access_Token: "",
      },
      ImgByteArray: "",
      ValidateCode: "",
    };
  },
  mounted() {
    if (this.$route.query.code !== undefined) {
      this.local$.removeItem("tdCode");
      this.local$.setItem("tdCode", this.$route.query.code);
    } else {
      if (this.local$.getItem("tdCode") === null) {
        wxService.getAuthorizationCode(process.env.NODE_ENV + "|/tdLogin|d");
      }
    }
    this.loadValidateCode();
  },
  methods: {
    async loadValidateCode() {
      let result = await AuthService.getValidateCode();

      if (result !== null) {
        let { Data } = result;

        this.ValidateCode = Data.ValidateCode;

        this.ImgByteArray = `data:image/jpeg;base64,${Data.ImgByteArray}`;
      }
    },
    async btnSubmit() {
      if (!this.params.Mobile) {
        this.toast$("请输入手机号!");
        return;
      }

      if (!this.params.Password) {
        this.toast$("请输入密码!");
        return;
      }

      if (
        this.encry$.MD5Encryption(this.params.ValidateCode) !==
        this.ValidateCode
      ) {
        this.toast$("请输入正确的验证码!");
        return;
      }

      this.indicator$.open("请稍后...");

      let wxParams = {};

      let user = this.local$.getItem("tdUser");

      wxParams.code = this.local$.getItem("tdCode");

      try {
        let accessToken = await wxService.getOpenId(wxParams);

        this.params.OpenID = accessToken.Data.Openid;

        this.params.Access_Token = accessToken.Data.Access_Token;

        this.local$.removeItem("tdOID");
        this.local$.setItem("tdOID", this.params.OpenID);
      } catch (err) {
        wxService.getAuthorizationCode(process.env.NODE_ENV + "|/tdLogin|d");
      }

      try {
        let result = await DoctorService.loginDoctor(this.params);

        let { Data } = result;

        if (!this.utils$.isEmpty(Data.IconPath)) {
          Data.IconPath = require("../assets/images/boy.png");
        }

        this.local$.removeItem("tdToken");
        this.local$.setItem("tdToken", Data.Password);

        this.local$.removeItem("tdUser");
        this.local$.setItem("tdUser", JSON.stringify(Data));

        let args = {
          doctorID: Data.DoctorID,
        };

        try {
          let hosResult = await HospitalService.getHospitalListByDoctor(args);

          Data.hospitalList = hosResult.Data;

          //重新将用户添加到缓存
          this.local$.removeItem("tdUser");
          this.local$.setItem("tdUser", JSON.stringify(Data));

          this.local$.removeItem("tdStatus");
          this.local$.setItem("tdStatus", true);

          //cookie过期时间1小時
          let exp = 60 * 60 * 1;
          //cookie键
          let cookie_key = "tdCookie";
          //cookie值，随机生成
          let cookie_value = "cookieStatus";
          this.cookies$.remove("tdCookie");
          this.cookies$.set(cookie_key, cookie_value, exp);

          this.toast$("登陆成功");
          this.$router.push({ name: "tdShared" });
          this.indicator$.close();
        } catch (err) {
          wxService.getAuthorizationCode(process.env.NODE_ENV + "|/tdLogin|d");
        }
      } catch (err) {
        wxService.getAuthorizationCode(process.env.NODE_ENV + "|/tdLogin|d");
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/login.vue